import axios from 'axios';

const blockscoutSearch = async (query) => {
    const url = `${process.env.REACT_APP_BLOCKSCOUT_GOERLI_BASE_URL}/search?q=${query}`;
    const response = await axios.get(url, {withCredentials: false});
    return response.data.items;
}

export default blockscoutSearch;